import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import BottomPopupDropdownOptions from '@components/BottomPopupDropdownOptions';
import CommonImage from '@components/CommonImage';

import { checkAnyUserType, checkUserType } from '@utils/Util';

const BottomPopup = ({
	type,
	length,
	selectedDesignIds,
	isZalando = false,
	onActionClick,
	isHideSetOrder,
	showUnSelectAll,
	isRequestFromTNA = false,
	isDisableFetchNextPage,
	remainingStyles,
	setPackOption = {}
}) => {
	const [showDropdown, setShowDropdown] = useState(false);
	const PLACE_ORDER_TYPES = ['ACCOUNT_MANAGER', 'PROJECT_MANAGER', 'MERCHANDISER', 'ADMIN'];
	const zalandoRef = useRef();
	const location = useLocation();

	const isSetProduct = () => {
		return parseInt(length.split('/')[0]) > 1;
	};

	let moreDropdownItems = [
		{
			text: isHideSetOrder && !isHideSetOrder() ? `Create ${isSetProduct() ? 'Set' : 'Pack'}` : '',
			onClick: () => onActionClick(isSetProduct() ? 'SET' : 'PACK')
		},
		{
			text: 'Tag',
			onClick: () => onActionClick('BULK_TAG')
		},
		{
			text: 'Move to draft',
			onClick: () => onActionClick('DO_ALL_DRAFT')
		},
		{
			text: 'Publish',
			onClick: () => onActionClick('PUBLISH')
		},
		{ text: 'Task update', onClick: () => onActionClick('TASK_UPDATE') }
	];

	let downloadDropdownItems = [
		{
			text: 'Presentation',
			onClick: () => onActionClick('PLAY_PRESENTATION')
		},
		{
			text: 'Techapck summary',
			onClick: () => onActionClick('DOWNLOAD_REPORT')
		}
	];

	let requestDropdownItems = [
		{
			text: 'Place order',
			onClick: () => {
				if (!isZalando) {
					onActionClick('PLACE_ORDER');
				} else {
					setShowDropdown(!showDropdown);
				}
			},
			show: checkAnyUserType(PLACE_ORDER_TYPES)
		},
		{
			text: 'Sample',
			onClick: () => onActionClick('SAMPLE')
		},
		{
			text: 'Quote',
			onClick: () => onActionClick('COSTING')
		}
	];

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (zalandoRef && !zalandoRef.current?.contains(event.target)) {
			setShowDropdown(false);
		}
	};

	const isRequestFromSuggestedCollection = () => {
		let paramList = new URLSearchParams(location.search);
		const requestFrom = paramList.get('status');
		return requestFrom === 'SUGGESTED_FOR_BUYER';
	};

	return (
		<div
			className={
				type && type === 'FAVOURITE_PAGE'
					? 'design-count-section bg-white design-list-count favourite-list-count shadow-8dp'
					: `design-count-section bg-white ${
							isRequestFromSuggestedCollection() ? '' : 'collection-details-design-count'
						}   shadow-8dp`
			}
		>
			<div className="count-info d-flex justify-content-between align-items-center">
				<div className="design-count">
					<p className="regular-14">{length}</p>
				</div>

				<div className="buttons d-flex align-items-center align-self-center">
					{type === 'COLLECTION_DETAILS' ? (
						<>
							{!showUnSelectAll && (
								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('SELECT_ALL')}
									>
										<span className="ml-1">Select 1st 30 Styles</span>
									</button>
									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
								</>
							)}
							{showUnSelectAll && (
								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('FETCH_NEXT_PAGE')}
										disabled={isDisableFetchNextPage}
									>
										<span className="ml-1">Select Next {remainingStyles} Styles</span>
									</button>
									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
								</>
							)}
							{!isRequestFromSuggestedCollection() && (
								<>
									{!checkUserType('FASHION_DESIGNER') && (
										<>
											{isZalando && showDropdown && (
												<div ref={zalandoRef} className="regular-shortcut-dropdown">
													<ul>
														<li
															className="regular-14 py-2 px-3"
															onClick={() => onActionClick('PLACE_ORDER')}
														>
															Regular
														</li>
														<li
															className="regular-14 py-2 px-3"
															onClick={() => onActionClick('ZALANDO')}
														>
															Shortcut
														</li>
													</ul>
												</div>
											)}
											{checkAnyUserType(PLACE_ORDER_TYPES) && (
												<button
													className="button text size36"
													onClick={() => {
														if (!isZalando) {
															onActionClick('PLACE_ORDER');
														} else {
															setShowDropdown(!showDropdown);
														}
													}}
												>
													<span className="mr-1">Place order</span>
												</button>
											)}
											<button
												className="button text size36"
												onClick={() => onActionClick('SAMPLE')}
											>
												<span className="ml-1">Sample</span>
											</button>
											<button
												className="button text size36"
												onClick={() => onActionClick('COSTING')}
											>
												<span className="mr-1">Costing</span>
											</button>

											<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
												|
											</span>
										</>
									)}
									<button
										className="button text size36"
										onClick={() => onActionClick('COLLECTION')}
									>
										<CommonImage src="/icons/add-round.svg" alt="add" />
										<span className="ml-1">Collection</span>
									</button>
									<>
										<div className="add-new-design">
											<button
												className="button text size36 px-0"
												type="button"
												id="moreDropdown2"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<CommonImage
													src="/icons/add-round.svg"
													alt="button-icon"
													className="mr-1"
												/>
												More
											</button>
											<div className="dropdown-menu" aria-labelledby="moreDropdown2">
												<ul>
													{moreDropdownItems.map((item) => {
														if (item.text !== '') {
															return (
																<li key={item.text}>
																	<span
																		onClick={
																			item.onClick ? item.onClick : null
																		}
																	>
																		{item.icon && (
																			<CommonImage
																				src={item.icon}
																				alt={item.text}
																				className="mr-1"
																			/>
																		)}
																		{item.text}
																	</span>
																</li>
															);
														}
													})}
												</ul>
											</div>
										</div>
									</>

									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
									<>
										<div className="add-new-design">
											<button
												className="button text size32 px-0"
												type="button"
												id="downloadDropdown"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<CommonImage
													src="/icons/download-gray-dark-02.svg"
													alt="button-icon"
													className="mr-1"
												/>
												Download
											</button>
											<div className="dropdown-menu" aria-labelledby="downloadDropdown">
												<ul>
													{downloadDropdownItems.map((item, index) => (
														<li key={index}>
															<span
																onClick={item.onClick ? item.onClick : null}
															>
																{item.icon && (
																	<CommonImage
																		src={item.icon}
																		alt={item.text}
																		className="mr-1"
																	/>
																)}{' '}
																{item.text}
															</span>
														</li>
													))}
												</ul>
											</div>
										</div>
									</>
								</>
							)}
							{isRequestFromSuggestedCollection() && (
								<button
									className="button text size36"
									onClick={() => onActionClick('REMOVE_PRODUCT')}
								>
									<span className="ml-1">Remove</span>
								</button>
							)}
						</>
					) : type === 'FAVOURITE_PAGE' ? (
						<>
							{!showUnSelectAll && (
								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('SELECT_ALL')}
									>
										<span className="ml-1">Select 1st 30 Styles</span>
									</button>
								</>
							)}
							{showUnSelectAll && (
								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('FETCH_NEXT_PAGE')}
										disabled={isDisableFetchNextPage}
									>
										<span className="ml-1">Select Next {remainingStyles} Styles</span>
									</button>
								</>
							)}

							<button
								className="button text size36"
								onClick={() => onActionClick('COLLECTION')}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
								<span className="ml-1">Collection</span>
							</button>
							<button
								className="button text size36"
								onClick={() => onActionClick('ADD_FOLDER')}
							>
								<CommonImage src="/icons/add-round.svg" alt="add" />
								<span className="ml-1"> Folder</span>
							</button>
							{!checkUserType('FASHION_DESIGNER') && (
								<div className="add-new-design">
									<button
										className="button text size32 d-flex align-items-center"
										type="button"
										id="requestDropdown"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<CommonImage
											src="/icons/add-round.svg"
											alt="button-icon"
											className="mr-1"
										/>
										Request
									</button>
									<div className="dropdown-menu" aria-labelledby="requestDropdown">
										<ul>
											{requestDropdownItems.map((item, index) => {
												if (item.show === false) return null;
												return (
													<li key={index}>
														<span onClick={item.onClick ? item.onClick : null}>
															{item.text}
														</span>
													</li>
												);
											})}
										</ul>
									</div>
								</div>
							)}
							<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
								|
							</span>
							<button
								className="button text size36"
								onClick={() => onActionClick('MOVE_TO_DRAFT')}
							>
								<span className="ml-1">Move to draft</span>
							</button>

							<button className="button text size36">
								<span
									className="ml-1"
									onClick={() => onActionClick('UPDATE_SAMPLE_LOCATION')}
								>
									Sample Location
								</span>
							</button>
							<BottomPopupDropdownOptions
								onActionClick={onActionClick}
								title="More"
								showIcon
								icon={`/icons/add-round.svg`}
								options={[
									{ id: 'ADD_TAG', title: 'Add Tag', value: 'ADD_TAG' },
									{ id: 'MOVE_TO_DRAFT', title: 'Move to draft', value: 'MOVE_TO_DRAFT' },
									{ id: 'TASK_UPDATE', title: 'Task update', value: 'TASK_UPDATE' },
									{
										id: 'INVENTORY_STICKER',
										title: 'Inventory & Sticker',
										value: 'INVENTORY_STICKER'
									},
									setPackOption
								]}
							/>
							<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
								|
							</span>
							<BottomPopupDropdownOptions onActionClick={onActionClick} />
						</>
					) : type === 'SAMPLE_PAGE' ? (
						<>
							{selectedDesignIds?.sample?.length > 0 && (
								<button
									className="button text size36"
									onClick={() => onActionClick('SAMPLE')}
								>
									<span className="ml-1">Sample request</span>
								</button>
							)}
							{selectedDesignIds?.costing?.length > 0 && (
								<button
									className="button text size36"
									onClick={() => onActionClick('COSTING')}
								>
									<span className="mr-1">Costing</span>
									{/* <img src="/icons/Right_arrow_Space.svg" alt="right" /> */}
								</button>
							)}
							{selectedDesignIds?.photoshoot?.length > 0 && (
								<button
									className="button text size36"
									onClick={() => onActionClick('PHOTOSHOOT')}
								>
									<span className="mr-1">Photoshoot</span>
									{/* <img src="/icons/Right_arrow_Space.svg" alt="right" /> */}
								</button>
							)}
						</>
					) : isRequestFromTNA ? (
						<>
							{!showUnSelectAll && (
								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('SELECT_ALL')}
									>
										<span className="ml-1">Select All</span>
									</button>
									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
								</>
							)}
							{showUnSelectAll && (
								<>
									<button
										className="button text size36"
										onClick={() => onActionClick('UN_SELECT_ALL')}
									>
										<span className="ml-1">Unselect All</span>
									</button>
									<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
										|
									</span>
								</>
							)}

							<button className="button text size36" onClick={() => onActionClick('DOWNLOAD')}>
								<CommonImage src={`/icons/download-icon.svg`} alt="" />
								<span className="ml-1">Download</span>
							</button>
						</>
					) : null}
				</div>

				{type === 'BLOCK_LIBRARY' && (
					<>
						<button
							className="button text size36"
							onClick={() => onActionClick('DOWNLOAD_REPORT')}
						>
							<CommonImage src="/icons/download-gray-dark-02.svg" alt="download" />
							<span className="ml-1">Techapck summary</span>
						</button>
					</>
				)}

				<div className="text-right close-icon" onClick={() => onActionClick('CLEAR')}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
					>
						<path
							d="M18.5038 5.7107C18.1138 5.3207 17.4838 5.3207 17.0938 5.7107L12.2038 10.5907L7.31383 5.7007C6.92383 5.3107 6.29383 5.3107 5.90383 5.7007C5.51383 6.0907 5.51383 6.7207 5.90383 7.1107L10.7938 12.0007L5.90383 16.8907C5.51383 17.2807 5.51383 17.9107 5.90383 18.3007C6.29383 18.6907 6.92383 18.6907 7.31383 18.3007L12.2038 13.4107L17.0938 18.3007C17.4838 18.6907 18.1138 18.6907 18.5038 18.3007C18.8938 17.9107 18.8938 17.2807 18.5038 16.8907L13.6138 12.0007L18.5038 7.1107C18.8838 6.7307 18.8838 6.0907 18.5038 5.7107Z"
							fill="#6A7181"
						/>
					</svg>
				</div>
			</div>
		</div>
	);
};

export default BottomPopup;
